import ApplicationController from './application_controller';

export default class extends ApplicationController {
  hideOverlay() {
    this.element.style.display = 'none';
  }
}